import { useParams } from "react-router-dom";
import { useState, useCallback, useMemo, useRef, useEffect } from "react";
//import { toast } from "react-toastify";

import { 
  Box,
  Collapse,
  IconButton, InputAdornment,
  OutlinedInput,
  Typography, Tabs, Tab, TextField,
  useTheme, 
  alpha
} from "@mui/material";

import styled from "styled-components";

import SearchIcon from "@mui/icons-material/Search"; // MUI의 검색 아이콘
import CloseIcon from '@mui/icons-material/Close';

import {
  addEdge,
  Background,
  Controls,
  Handle,
  MiniMap,
  Position,
  ReactFlow, ReactFlowProvider,
  useNodesState, useEdgesState, useReactFlow,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import {
  standardLawColumns,
  standardGoalColumns,
  standardCourseColumns,
  standardSafeOrgColumns,
  standardSafeRoleManagementColumns,
} from "../../../constants/columns";

import { 
  useGetTableData,
  useCreateTableData, 
  usePutTableData,
  useDeleteTableData, 
} from "../../../components/Table/hooks";
import { NewTableTemplate } from "../../../components/Table/TableTemplate";
import { ModalTemplate } from "../../../components/Table/ModalTemplate";
import { 
  BulletTextField, BreadcrumbsTable,
  ConfirmDialog, 
  deepCopy,
  normalizeToArray,
  SnackbarAlert, 
} from "../../../components/common/HelperFunc";
import { EmployeeBulkPicker } from "../../../components/common/EmployeeSelect";
import * as message from "../../../constants/messages";
import Buttons from "../../../../common/Buttons";
import { FONT_PROPS } from "../../../styles/colors";

///////////////////////////////
// 스타일
///////////////////////////////

// 테이블 컨테이너 스타일
const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 32px 20px 32px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

///////////////////////////////
// 정보관리의 안전보건관리체계 컴포넌트
///////////////////////////////
const PARENT_TITLE = "정보관리";
const CHILD_TITLE = "안전보건관리체계";
export function StandardSafetyRegulations() {
  const theme = useTheme();
  //const { group_code, project_code } = useParams();

  // 탭 상태관리
  const [tabValue, setTabValue] = useState('one');
  const handleTabChange = (event, newValue) => setTabValue(newValue);

  ////////////////////////
  // 렌더링
  ////////////////////////
  function renderData() {
    return (
      <>
        {/* 탭 기능 */}
        <Box sx={{ display: 'flex', borderBottom: `1px solid ${theme.palette.divider}`,}}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="basic tabs example"
            sx={{
              borderBottom: 'none',
              marginLeft: '32px',
              '& .MuiTabs-indicator': {
                backgroundColor: theme.palette.primary.main,
              },
            }}
          >
            <Tab value="one" label="안전보건 법규" 
              sx={{
                borderLeft: `1px solid ${theme.palette.divider}`,
                borderRight: `1px solid ${theme.palette.divider}`,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderTopLeftRadius: '0.375rem',
                borderTopRightRadius: '0.375rem',
                marginRight: '0.3rem',
                bgcolor: tabValue === 'one' 
                  ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                  : 'var(--mui-palette-background-paper)',
                fontFamily: FONT_PROPS.PRIMARY,
                fontWeight: FONT_PROPS.MEDIUM,
                fontSize: '16px',
              }}
            />
            <Tab value="two" label="안전보건경영 방침"
              sx={{
                borderLeft: `1px solid ${theme.palette.divider}`,
                borderRight: `1px solid ${theme.palette.divider}`,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderTopLeftRadius: '0.375rem',
                borderTopRightRadius: '0.375rem',
                marginRight: '0.3rem',
                bgcolor: tabValue === 'two' 
                  ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                  : 'var(--mui-palette-background-paper)',
                fontFamily: FONT_PROPS.PRIMARY,
                fontWeight: FONT_PROPS.MEDIUM,
                fontSize: '16px',
              }}
            />
            <Tab value="three" label="안전보건경영 목표"
              sx={{
                borderLeft: `1px solid ${theme.palette.divider}`,
                borderRight: `1px solid ${theme.palette.divider}`,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderTopLeftRadius: '0.375rem',
                borderTopRightRadius: '0.375rem',
                marginRight: '0.3rem',
                bgcolor: tabValue === 'three' 
                  ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                  : 'var(--mui-palette-background-paper)',
                fontFamily: FONT_PROPS.PRIMARY,
                fontWeight: FONT_PROPS.MEDIUM,
                fontSize: '16px',
              }}
            />
            <Tab value="four" label="안전보건경영 조직도"
              sx={{
                borderLeft: `1px solid ${theme.palette.divider}`,
                borderRight: `1px solid ${theme.palette.divider}`,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderTopLeftRadius: '0.375rem',
                borderTopRightRadius: '0.375rem',
                marginRight: '0.3rem',
                bgcolor: tabValue === 'four' 
                  ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                  : 'var(--mui-palette-background-paper)',
                fontFamily: FONT_PROPS.PRIMARY,
                fontWeight: FONT_PROPS.MEDIUM,
                fontSize: '16px',
              }}
            />
            <Tab value="five" label="안전보건관리체계 조직 역할"
              sx={{
                borderLeft: `1px solid ${theme.palette.divider}`,
                borderRight: `1px solid ${theme.palette.divider}`,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderTopLeftRadius: '0.375rem',
                borderTopRightRadius: '0.375rem',
                marginRight: '0.3rem',
                bgcolor: tabValue === 'five' 
                  ? 'rgb(var(--mui-palette-primary-mainChannel) / 0.16)' 
                  : 'var(--mui-palette-background-paper)',
                fontFamily: FONT_PROPS.PRIMARY,
                fontWeight: FONT_PROPS.MEDIUM,
                fontSize: '16px',
              }}
            />
          </Tabs>
        </Box>

        {/* 안전보건 법규 */}
        {tabValue === 'one' && <SafeLaw />}
        {/* 안전보건경영 방침 */}
        {tabValue === 'two' && <SafeCourse />}
        {/* 안전보건경영 목표 */}
        {tabValue === 'three' && <SafeGoal />}
        {/* 안전보건경영 조직도 */}
        {tabValue === 'four' && (
          <ReactFlowProvider>
            <SafeOrg />
          </ReactFlowProvider>
        )}
        {/* 안전보건관리체계 조직 역할 */}
        {tabValue === 'five' && <SafeRoleManagement />}
      </>
    );
  }

  // StandardSafetyRegulations 렌더링
  return (
    <Box sx={{ bgcolor: 'var(--mui-palette-background-paper)',height: '100%',display: 'flex',flexDirection: 'column'}}>
      {/* 브레드크럼 + 타이틀 */} 
      <BreadcrumbsTable parentTitle={PARENT_TITLE} childTitle={CHILD_TITLE} useTab={true} />
      {/* 테이블 표시 */}
      {renderData()}
    </Box>
  );
}

//---------------

// 안전보건 법규
const SafeLaw = () => {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 데이터 조회 요청
  const getData = useGetTableData(
    "request",
    "/getSafeLaw", // 서버 요청 경로
    group_code,
    project_code
  );
  // 데이터 생성 요청
  const postData = useCreateTableData( 
    "request",
    "/postSafeLaw",
    group_code,
    project_code
  );
  // 데이터 수정 요청
  const putData = usePutTableData( 
    "request",
    "/putSafeLaw",
    group_code,
    project_code
  );
  // 데이터 삭제 요청
  const deleteData = useDeleteTableData(
    "request",
    "/deleteSafeLaw",
    group_code,
    project_code
  );

  // 데이터 업데이트 알람 상태 관리
  const [dataAlert, setDataAlert] = useState({
    isOpen: false,
    message: '',
    severity:'' // 'success' | 'error' | 'warning' | 'info'
  });
  const openDataAlert = (message, severity = 'success') => {
    setDataAlert({
      ...dataAlert,
      isOpen: true,
      message: message,
      severity: severity
    });
  };
  const closeDataAlert = () => {
    setDataAlert({
      ...dataAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 테이블 참조
  const tableRef = useRef();
  const clearSelection = () => { tableRef.current?.clearSelection(); };
  const getSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

  // 테이블의 상단 툴바 커스터마이징 관련 내용
  const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
  const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
  const customTableTopToolbar = (table) => (
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
      {/* 왼쪽 영역 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* TODO: */}
      </Box>
      {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* 검색창 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setShowSearch((prev) => !prev)}>
            <SearchIcon />
          </IconButton>
      
          <Collapse in={showSearch} orientation="horizontal">
            <TextField
              size="small"
              placeholder="검색"
              value={globalFilter}
              onChange={(e) => {
                setGlobalFilter(e.target.value);
                table.setGlobalFilter(e.target.value);
              }}
              sx={{ minWidth: 200 }}
              variant="outlined"
              slots={{
                input: OutlinedInput,
              }}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setGlobalFilter('');
                        table.setGlobalFilter('');
                        setShowSearch(false); // 닫기
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                  ),
                }
              }}
            />
          </Collapse>
        </Box>
        {/* 추가 버튼 */}
        <Buttons.Add
          onClick={() => openAddModal()} // 행 생성 다이얼로그 열기
          sx={{ padding: '12px 16px' }}
        />
        {/* 삭제 버튼 */}
        <Buttons.Delete 
          onClick={openDeleteModal} // 행 삭제 로직 실행
          disabled={table.getSelectedRowModel().rows.length === 0}
          sx={{ padding: '12px 16px' }}
        />    
      </Box>
    </Box>
  );

  // 안전보건 법규 추가 모달 상태 관리
  const [showAddModal, setShowAddModal] = useState({ isOpen: false });
  const openAddModal = (rowData) => {
    setShowAddModal({
      ...showAddModal,
      isOpen: true
    });
  };
  const closeAddModal = () =>{
    setShowAddModal({
      ...showAddModal,
      isOpen: false
    });
  };
  // DB 업데이트(추가 데이터)
  const updateAddData = async (addData) => {
    try {
      //console.log("새로운 데이터: ", addData);

      // 데이터베이스 업데이트
      const result = await postData.mutateAsync(addData);
      if(result.status === 200) {
        openDataAlert(message.addSuccess);
      }

      // 생성 모달 초기화
      closeAddModal();
    }
    catch (error) {
      console.error("데이터 추가 중 오류 발생:", error);
    }
  };

  // 안전보건 법규 수정 모달 상태 관리
  const [showEditModal, setShowEditModal] = useState({
    isOpen: false,
    rowData: null,
  });
  const openEditModal = (rowData) => {
    setShowEditModal({
      ...showEditModal,
      isOpen: true,
      rowData: rowData,
    });
  };
  const closeEditModal = () =>{
    setShowEditModal({
      ...showEditModal,
      isOpen: false,
      rowData: null,
    });
  };
  // 테이블의 행(row) 수정 액션
  const customRenderRowActionContent = (rowData) => {
    return(
      <Buttons.Edit
        onClick={(event) =>{
          event.stopPropagation(); // 이벤트 전파 중단
          openEditModal(rowData);
        }}
        sx={{ padding: '8px 12px' }}
      />
    );
  };
  // DB 업데이트 (수정 데이터)
  const updateEditData = async (updateData) => {
    //console.log(updateData);
    try {
      const result = await putData.mutateAsync(updateData);
      if(result.status === 200) {
        openDataAlert(message.updateEditSuccess);
      }

      // 수정 모달 초기화
      closeEditModal();
    }
    catch (error) {
        console.error("데이터 수정 중 오류 발생:", error);
    }
  }

  // 행(row) 삭제 관련 함수 및 상태
  const [deleteModal, setDeleteModal] = useState({ isOpen: false });
  const openDeleteModal = () => setDeleteModal({ isOpen: true });
  const closeDeleteModal = () => setDeleteModal({ isOpen: false });
  // DB 업데이트 (삭제 데이터)
  const updateDeleteData = async () => {
    closeDeleteModal();
    //console.log('✅ 확인 눌림 → 다음 동작 실행');
    try {

      // 선택된 행(row) 가져오기
      const selectedRows = getSelectedRows().map((row) => row.original);
      // 선택된 행(row)의 id 가져오기
      const selectedIds = selectedRows.map((row) => row.law_id);

      // 데이터베이스 업데이트
      const result = await deleteData.mutateAsync({
        deleteParam: 'law_id',
        param: selectedIds,
      });

      if(result.status === 200) {
        openDataAlert(message.deleteSuccess);
      }

      // 선택 상태 초기화
      clearSelection();
      
    }
    catch (error) {
      console.error("데이터 삭제 중 오류 발생:", error);
    }
  };

  // SafeLaw 렌더링
  return (
    <TableContainer>
      {/** 안전보건 법규 테이블 표시 */}
      <NewTableTemplate
        ref={tableRef}
        columns={standardLawColumns}
        data={getData.data}
        topToolbarContent={customTableTopToolbar}
        renderRowActionContent={customRenderRowActionContent}
        enableCustomGlobalFilter={true}
        templateSX ={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0.375rem", 
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
        }}
      />
      {/* 행(row) 추가 모달 */}
      <SafeLawCreateRowModal 
        isOpen={showAddModal.isOpen}
        rowData={[...getData.data]}
        onConfirm={updateAddData}
        onCancel={closeAddModal}
      />
      {/* 행(row) 수정 모달 */}
      <SafeLawEditRowModal 
        isOpen={showEditModal.isOpen}
        originalRowData={showEditModal.rowData}
        onConfirm={updateEditData}
        onCancel={closeEditModal}
      />
      {/* 삭제 메시지 */}
      <ConfirmDialog
        open={deleteModal.isOpen}
        title="정말 삭제하시겠어요?"
        message="삭제하면 복구할 수 없습니다."
        onConfirm={updateDeleteData}
        onCancel={closeDeleteModal}
      />
      {/* 데이터 알람 */}
      <SnackbarAlert 
        open={dataAlert.isOpen}
        onClose={closeDataAlert}
        message={dataAlert.message}
        severity={dataAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        //anchorOrigin = {{vertical: "top", horizontal: "center"}}
      />
    </TableContainer>
  );
};
// 안전보건법규의 행(row) 추가 모달
const SafeLawCreateRowModal = ({ isOpen, originalRowData, onConfirm, onCancel }) => {
  const theme = useTheme();
  // const { group_code, project_code } = useParams();

  // 유효성 검사 알람 상태 관리
  const [validationAlert, setValidationAlert] = useState({
    isOpen: false,
    message: '',
    severity: '',
  });
  const openValidationAlert = (message, severity = 'error') => {
    setValidationAlert({
      ...validationAlert,
      isOpen: true,
      message: message,
      severity: severity,
    });
  };
  const closeValidationAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setValidationAlert({
      ...validationAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 추가 행 데이터 관리
  const [addData, setAddData] = useState([]);
  const clearAddData = () => setAddData([]);

  // 행 추가 완료
  const handleApplyAdd = () => {

    if(checkEmptyData(addData)) {
      openValidationAlert(message.notAllowedEmpty);
      //toast.error(message.notAllowedEmpty);
      return;
    } 

    //console.log("새로운 데이터: ", addData);
    const data = { 
      ...addData, 
      law_active_date: transFormatDateForDB(addData.law_active_date, "date"),
    };

    onConfirm(data);
    clearAddData();
  };

  ////////////////////////
  // Helper Functions
  ////////////////////////

  // 날짜 데이터 포맷 변경 (UI -> DB)
  const transFormatDateForDB = (value, type) => {
    if (!value) return null;
    const dayjsValue = dayjs(value);
    if (!dayjsValue.isValid()) return null;
    if (type === "date") {
      return dayjsValue.format("YYYY-MM-DD");
    }
    if (type === "datetime") {
      return dayjsValue.format("YYYY-MM-DD HH:mm:ss");
    }
    return value;
  };

  // 데이터 빈칸 체크
  const checkEmptyData = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때
    if(tempData.length === 0) { 
      return true;
    }

    // 데이터가 있을 때
    const hasValidData = tempData.some(
      item => !item.law_name || !item.law_active_date || !item.law_url || !item.law_information
    );
    return hasValidData;
  };

  // SafeLawCreateRowModal 렌더링
  return (
    <ModalTemplate
      isOpen={isOpen}
      handleConfirm={handleApplyAdd}
      handleCancel={() => {
        clearAddData();
        onCancel();
      }}
      title="추가하기"
      cancelText="취소"
      confirmText="추가"
    >
      <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 3, py: 2}}>
        {/* 법규명 */}
        <TextField
          label={'법규명'}
          value={addData?.law_name || ""}
          fullWidth
          onChange={(e) => {
            setAddData({
              ...addData,
              law_name: e.target.value,
            });
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background.paper,
            },
          }}
        />
        {/* 시행일자 */}
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="ko"
          //key={column.accessorKey}
        >
          <DatePicker
            label={'시행일자'}
            value={addData?.law_active_date || null}
            onChange={(e) => {
              setAddData({
                ...addData,
                law_active_date: e,
              });
            }}
            slotProps={{
              textField: {
                fullWidth: true,
                // sx: {
                //   marginTop: '16px',
                //   marginBottom: '8px',
                // },
              },
            }}
          />
        </LocalizationProvider>
        {/* 관련 사이트 */}
        <TextField
          label={'관련 사이트'}
          value={addData?.law_url || ""}
          fullWidth
          onChange={(e) => {
            setAddData({
              ...addData,
              law_url: e.target.value,
            });
          }}
        />
        {/* 법규 정보 */}
        <TextField
          label={'법규 정보'}
          value={addData?.law_information || ""}
          fullWidth
          onChange={(e) => {
            setAddData({
              ...addData,
              law_information: e.target.value,
            });
          }}
        />
      </Box>

      {/* 유효성 검사 알람 */}
      <SnackbarAlert 
        open={validationAlert.isOpen}
        onClose={closeValidationAlert}
        message={validationAlert.message}
        severity={validationAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        // anchorOrigin = {{vertical: "top", horizontal: "center"}}
        snackBarSX={{width: '80%'}}
      />  
    </ModalTemplate>
  );
}
// 안전보건법규의 행(row) 수정 모달 컴포넌트
const SafeLawEditRowModal = ({ isOpen, originalRowData, onConfirm, onCancel }) => {
  // const theme = useTheme();
  // const { group_code, project_code } = useParams();

  // 유효성 검사 알람 상태 관리(빈칸)
  const [validationAlert, setValidationAlert] = useState({
    isOpen: false,
    message: '',
    severity: '',
  });
  const openValidationAlert = (message, severity = 'error') => {
    setValidationAlert({
      ...validationAlert,
      isOpen: true,
      message: message,
      severity: severity,
    });
  };
  const closeValidationAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setValidationAlert({
      ...validationAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 수정 행 데이터 관리
  const [editData, setEditData] = useState([]);
  const clearEditData = () => setEditData([]);
  useEffect(() =>{
    if(!originalRowData) {
      return;
    }
    setEditData(
      transFormatDateForUI(originalRowData, "law_active_date")
    );
  },[originalRowData])

  // 행 수정
  const handleEditRowConfirm = () => {

    if(checkEmptyData(editData)) {
      openValidationAlert(message.notAllowedEmpty);
      //toast.error(message.notAllowedEmpty);
      return;
    } 
    //console.log("수정된 데이터:", editedRow);
    
    // 데이터 포맷 변경
    const data = { 
      ...editData, 
      law_active_date: transFormatDateForDB(editData.law_active_date, "date"),
    };
    
    onConfirm(data);
    clearEditData();
  };

  ////////////////////////
  // Helper Functions
  ////////////////////////

  // 날짜 데이터 포맷 변경 (UI -> DB)
  const transFormatDateForDB = (value, type) => {
    if (!value) return null;
    const dayjsValue = dayjs(value);
    if (!dayjsValue.isValid()) return null;
    if (type === "date") {
      return dayjsValue.format("YYYY-MM-DD");
    }
    if (type === "datetime") {
      return dayjsValue.format("YYYY-MM-DD HH:mm:ss");
    }
    return value;
  };

  // 날짜 데이터 포맷 변경 (DB -> UI)
  const transFormatDateForUI = (value, key) => {
    if(!value[key]) {
      return value;
    }
    const tempData = { ...value };
    const changeData = dayjs(tempData[key]);
    tempData[key] = changeData;

    return tempData;
  };

  // 데이터 빈칸 체크
  const checkEmptyData = (data) => {
      const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

      // 데이터가 없을 때
      if(tempData.length === 0) { 
          return true;
      }

      // 데이터가 있을 때
      const hasValidData = tempData.some(
        item => !item.law_name || !item.law_active_date || !item.law_url || !item.law_information
      );
      return hasValidData;
  };

  // EditRowModalContent 렌더링
  return (
    <ModalTemplate
      isOpen={isOpen}
      handleConfirm={handleEditRowConfirm}
      handleCancel={() => {
        clearEditData();
        onCancel();
      }}
      title="수정하기"
      cancelText="취소"
      confirmText="수정"
      contentSX={{ gap: "24px" }}
    >
      <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 3, py: 2}}>
        {/* 법규명 */}
        <TextField
          label={'법규명'}
          value={editData?.law_name || ""}
          fullWidth
          onChange={(e) => {
            setEditData({
              ...editData,
              law_name: e.target.value,
            });
          }}
        />
        {/* 시행일자 */}
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="ko"
          //key={column.accessorKey}
        >
          <DatePicker
            label={'시행일자'}
            value={editData?.law_active_date || null}
            onChange={(e) => {
              setEditData({
                ...editData,
                law_active_date: e,
              });
            }}
            slotProps={{
              textField: {
                fullWidth: true,
                // sx: {
                //   marginTop: '16px',
                //   marginBottom: '8px',
                // },
              },
            }}
          />
        </LocalizationProvider>
        {/* 관련사이트 */}
        <TextField
          label={'관련사이트'}
          value={editData?.law_url || ""}
          fullWidth
          onChange={(e) => {
            setEditData({
              ...editData,
              law_url: e.target.value,
            });
          }}
        />
        {/* 법규정보 */}
        <TextField
          label={'법규정보'}
          value={editData?.law_information || ""}
          fullWidth
          onChange={(e) => {
            setEditData({
              ...editData,
              law_information: e.target.value,
            });
          }}
        />
      </Box>

      {/* 유효성 검사 알람 */}
      <SnackbarAlert 
        open={validationAlert.isOpen}
        onClose={closeValidationAlert}
        message={validationAlert.message}
        severity={validationAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        // anchorOrigin = {{vertical: "top", horizontal: "center"}}
        snackBarSX={{width: '80%'}}
      />  
    </ModalTemplate>
  );
}

//---------------

// 안전보건경영 방침
const SafeCourse = () => {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 데이터 조회 요청
  const getData = useGetTableData(
    "request",
    "/getSafeCourse", // 서버 요청 경로
    group_code,
    project_code
  );
  // 데이터 생성 요청
  const postData = useCreateTableData( 
    "request",
    "/postSafeCourse",
    group_code,
    project_code
  );
  // 데이터 수정 요청
  const putData = usePutTableData( 
    "request",
    "/putSafeCourse",
    group_code,
    project_code
  );
  // 데이터 삭제 요청
  const deleteData = useDeleteTableData(
    "request",
    "/deleteSafeCourse",
    group_code,
    project_code
  );

  // 데이터 업데이트 알람 상태 관리
  const [dataAlert, setDataAlert] = useState({
    isOpen: false,
    message: '',
    severity:'' // 'success' | 'error' | 'warning' | 'info'
  });
  const openValidationAlert = (message, severity = 'success') => {
    setDataAlert({
      ...dataAlert,
      isOpen: true,
      message: message,
      severity: severity
    });
  };
  const closeValidationAlert = () => {
    setDataAlert({
      ...dataAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 테이블 참조
  const tableRef = useRef();
  const clearSelection = () => { tableRef.current?.clearSelection(); };
  const getSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

  // 테이블의 상단 툴바 커스터마이징 관련 내용
  const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
  const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
  const customTableTopToolbar = (table) => (
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
      {/* 왼쪽 영역 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* TODO: */}
      </Box>

      {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* 검색창 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setShowSearch((prev) => !prev)}>
            <SearchIcon />
          </IconButton>
        
          <Collapse in={showSearch} orientation="horizontal">
            <TextField
              size="small"
              placeholder="검색"
              value={globalFilter}
              onChange={(e) => {
                setGlobalFilter(e.target.value);
                table.setGlobalFilter(e.target.value);
              }}
              sx={{ minWidth: 200 }}
              variant="outlined"
              slots={{
                input: OutlinedInput,
              }}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setGlobalFilter('');
                        table.setGlobalFilter('');
                        setShowSearch(false); // 닫기
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                  ),
                }
              }}
            />
          </Collapse>
        </Box>
        {/* 추가 버튼 */}
        <Buttons.Add
          onClick={() => openAddModal()} // 행 생성 다이얼로그 열기
          sx={{ padding: '12px 16px' }}
        />
        {/* 삭제 버튼 */}
        <Buttons.Delete 
          onClick={openDeleteModal} // 행 삭제 로직 실행
          disabled={table.getSelectedRowModel().rows.length === 0}
          sx={{ padding: '12px 16px' }}
        />    
      </Box>
    </Box>
  );

  // 안전보건경영 방침 추가 모달 상태 관리
  const [showAddModal, setShowAddModal] = useState({ isOpen: false });
  const openAddModal = () => {
    setShowAddModal({
      ...showAddModal,
      isOpen: true,
    });
  };
  const closeAddModal = () =>{
    setShowAddModal({
      ...showAddModal,
      isOpen: false,
    });
  };
  // DB 업데이트 (생성 데이터)
  const updateAddData = async (addData) => {
    try {
      //console.log("새로운 데이터: ", addData);

      // 데이터베이스 업데이트
      const result = await postData.mutateAsync(addData);
      if(result.status === 200) {
        openValidationAlert(message.addSuccess);
      }

      // 생성 모달 초기화
      closeAddModal();
    }
    catch (error) {
      console.error("데이터 추가 중 오류 발생:", error);
    }
  };

  // 안전보건경영 방침 수정 모달 상태 관리
  const [showEditModal, setShowEditModal] = useState({
    isOpen: false,
    rowData: null,
  });
  const openEditModal = (rowData) => {
    setShowEditModal({
      ...showEditModal,
      isOpen: true,
      rowData: rowData,
    });
  };
  const closeEditModal = () =>{
    setShowEditModal({
      ...showEditModal,
      isOpen: false,
      rowData: null,
    });
  };
  // 테이블의 행(row) 수정 액션
  const customRenderRowActionContent = (rowData) => {
    return(
      <Buttons.Edit
        onClick={(event) =>{
          event.stopPropagation(); // 이벤트 전파 중단
          openEditModal(rowData);
        }}
        sx={{ padding: '8px 12px' }}
      />
    );
  };
  // DB 업데이트 (수정 데이터)
  const updateEditData = async (updateData) => {
    //console.log(updateData);
    try {
      const result = await putData.mutateAsync(updateData);
      if(result.status === 200) {
        openValidationAlert(message.updateEditSuccess);
      }

      // 수정 모달 초기화
      closeEditModal();
    }
    catch (error) {
        console.error("데이터 수정 중 오류 발생:", error);
    }
  }
  
  // 행(row) 삭제 관련 함수 및 상태
  const [deleteModal, setDeleteModal] = useState({ isOpen: false });
  const openDeleteModal = () => setDeleteModal({ isOpen: true });
  const closeDeleteModal = () => setDeleteModal({ isOpen: false });
  // DB 업데이트 (삭제 데이터)
  const updateDeleteData = async () => {
    closeDeleteModal();
    //console.log('✅ 확인 눌림 → 다음 동작 실행');
    try {

      // 선택된 행(row) 가져오기
      const selectedRows = getSelectedRows().map((row) => row.original);
      // 선택된 행(row)의 id 가져오기
      const selectedIds = selectedRows.map((row) => row.course_id);

      // 데이터베이스 업데이트
      const result = await deleteData.mutateAsync({
        deleteParam: 'course_id',
        param: selectedIds,
      });

      if(result.status === 200) {
        openValidationAlert(message.deleteSuccess);
      }

      // 선택 상태 초기화
      clearSelection();
      
    }
    catch (error) {
      console.error("데이터 삭제 중 오류 발생:", error);
    }
  };

  return (
    <TableContainer>
      {/** 안전보건경격 방침 테이블 표시 */}
      <NewTableTemplate 
        ref={tableRef}
        columns={standardCourseColumns}
        data={getData.data}
        //CreateRowModal={CreateRowModalContent}
        //EditRowModal={EditRowModalContent}
        //onDeleteRows={handleDeleteRows}
        topToolbarContent={customTableTopToolbar}
        renderRowActionContent={customRenderRowActionContent}
        enableCustomGlobalFilter={true}
        templateSX ={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0.375rem",
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
        }}
      />
      {/* 행(row) 추가 모달 */}
      <SafeCourseCreateRowModal 
        isOpen={showAddModal.isOpen}
        originalRowData={[...getData.data]}
        onConfirm={updateAddData}
        onCancel={closeAddModal}
      />
      {/* 행(row) 수정 모달 */}
      <SafeCourseEditRowModal 
        isOpen={showEditModal.isOpen}
        originalRowData={showEditModal.rowData}
        onConfirm={updateEditData}
        onCancel={closeEditModal}
      />
      {/* 삭제 메시지 */}
      <ConfirmDialog
        open={deleteModal.isOpen}
        title="정말 삭제하시겠어요?"
        message="삭제하면 복구할 수 없습니다."
        onConfirm={updateDeleteData}
        onCancel={closeDeleteModal}
      />
      {/* 데이터 알람 */}
      <SnackbarAlert
        open={dataAlert.isOpen}
        onClose={closeValidationAlert}
        message={dataAlert.message}
        severity={dataAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        //anchorOrigin = {{vertical: "top", horizontal: "center"}}
      />
    </TableContainer>
  );
};
// 안전보건경영 방침의 행(row) 추가 모달
const SafeCourseCreateRowModal = ({ isOpen, originalRowData, onConfirm, onCancel }) => {
  const theme = useTheme();
  // const { group_code, project_code } = useParams();

  // 유효성 검사 알람 상태 관리(빈칸)
  const [validationAlert, setValidationAlert] = useState({
    isOpen: false,
    message: '',
    severity: '',
  });
  const openValidationAlert = (message, severity = 'error') => {
    setValidationAlert({
      ...validationAlert,
      isOpen: true,
      message: message,
      severity: severity,
    });
  };
  const closeValidationAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setValidationAlert({
      ...validationAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 추가 행 데이터 관리
  const [addData, setAddData] = useState([]);
  const clearAddData = () => setAddData([]);
  
  // 행 추가 완료
  const handleApplyAdd = () => {

    if(checkEmptyData(addData)) {
      openValidationAlert(message.notAllowedEmpty);
      //toast.error(message.notAllowedEmpty);
      return;
    } 

    onConfirm(addData);
    clearAddData();
  };

  // 데이터 빈칸 체크
  const checkEmptyData = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때
    if(tempData.length === 0) { 
      return true;
    }

    // 데이터가 있을 때
    const hasValidData = tempData.some(
      item => !item.course_description
    );
    return hasValidData;
  };

  // SafeCourseCreateRowModal 렌더링
  return (
    <ModalTemplate
      isOpen={isOpen}
      handleConfirm={handleApplyAdd}
      handleCancel={() => {
        clearAddData();
        onCancel();
      }}
      title="추가하기"
      cancelText="취소"
      confirmText="추가"
    >
      <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 3, py: 2}}>
        {/* 방침 */}
        <TextField
          label={'방침'}
          value={addData?.course_description || ""}
          fullWidth
          onChange={(e) => {
            setAddData({
              ...addData,
              course_description: e.target.value,
            });
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background.paper,
            },
          }}
        />
      </Box>

      {/* 유효성 검사 알람 */}
      <SnackbarAlert 
        open={validationAlert.isOpen}
        onClose={closeValidationAlert}
        message={validationAlert.message}
        severity={validationAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        // anchorOrigin = {{vertical: "top", horizontal: "center"}}
        snackBarSX={{width: '80%'}}
      />  
    </ModalTemplate>
  );
}
// 안전보건경영 방침의 행(row) 수정 모달
const SafeCourseEditRowModal = ({ isOpen, originalRowData, onConfirm, onCancel }) => {
  // 유효성 검사 알람 상태 관리
  const [validationAlert, setValidationAlert] = useState({
    isOpen: false,
    message: '',
    severity: '',
  });
  const openValidationAlert = (message, severity = 'error') => {
    setValidationAlert({
      ...validationAlert,
      isOpen: true,
      message: message,
      severity: severity,
    });
  };
  const closeValidationAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setValidationAlert({
      ...validationAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 수정 행 데이터 관리
  const [editData, setEditData] = useState([]);
  const clearEditData = () => setEditData([]);
  useEffect(() =>{
    setEditData(originalRowData);
  },[originalRowData])

  // 행 수정 완료
  const handleApplyEdit = () => {

    if(checkEmptyData(editData)) {
      openValidationAlert(message.notAllowedEmpty);
      return;
    } 
    //console.log("수정된 데이터:", editData);

    onConfirm(editData);
    clearEditData();
  };

  // 데이터 빈칸 체크
  const checkEmptyData = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때
    if(tempData.length === 0) { 
      return true;
    }

    // 데이터가 있을 때
    const hasValidData = tempData.some(
      item => !item.course_description
    );
    return hasValidData;
  };

  // SafeCourseEditRowModal 렌더링
  return (
    <ModalTemplate
      isOpen={isOpen}
      handleConfirm={handleApplyEdit}
      handleCancel={() => {
        clearEditData();
        onCancel();
      }}
      title="수정하기"
      cancelText="취소"
      confirmText="수정"
    >
      <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 3, py: 2}}>
        {/* 방침 */}
        <TextField
          label={'방침'}
          value={editData?.course_description || ""}
          fullWidth
          onChange={(e) => {
            setEditData({
              ...editData,
              course_description: e.target.value,
            });
          }}
        />
      </Box>

      {/* 유효성 검사 알람 */}
      <SnackbarAlert 
        open={validationAlert.isOpen}
        onClose={closeValidationAlert}
        message={message.notAllowedEmpty}
        severity={validationAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        // anchorOrigin = {{ vertical: "top", horizontal: "center" }}
        snackBarSX={{width: '80%'}}
      />
    </ModalTemplate>
  );
}

//---------------

// 안전보건경영 목표
const SafeGoal = () => {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 데이터 조회 요청
  const getData = useGetTableData(
    "request",
    "/getSafeGoal", // 서버 요청 경로
    group_code,
    project_code
  );
  // 데이터 생성 요청
  const postData = useCreateTableData( 
    "request",
    "/postSafeGoal",
    group_code,
    project_code
  );
  // 데이터 수정 요청
  const putData = usePutTableData( 
    "request",
    "/putSafeGoal",
    group_code,
    project_code
  );
  // 데이터 삭제 요청
  const deleteData = useDeleteTableData(
    "request",
    "/deleteSafeGoal",
    group_code,
    project_code
  );

  // 데이터 업데이트 알람 상태 관리
  const [dataAlert, setDataAlert] = useState({
    isOpen: false,
    message: '',
    severity:'' // 'success' | 'error' | 'warning' | 'info'
  });
  const openDataAlert = (message, severity = 'success') => {
    setDataAlert({
      ...dataAlert,
      isOpen: true,
      message: message,
      severity: severity
    });
  };
  const closeDataAlert = () => {
    setDataAlert({
      ...dataAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 테이블 참조
  const tableRef = useRef();
  const clearSelection = () => { tableRef.current?.clearSelection(); };
  const getSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

  // 테이블의 상단 툴바 커스터마이징 관련 내용
  const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
  const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
  const customTableTopToolbar = (table) => (
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
      {/* 왼쪽 영역 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* TODO: */}
      </Box>
      {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* 검색창 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setShowSearch((prev) => !prev)}>
            <SearchIcon />
          </IconButton>
        
          <Collapse in={showSearch} orientation="horizontal">
            <TextField
              size="small"
              placeholder="검색"
              value={globalFilter}
              onChange={(e) => {
                setGlobalFilter(e.target.value);
                table.setGlobalFilter(e.target.value);
              }}
              sx={{ minWidth: 200 }}
              variant="outlined"
              slots={{
                input: OutlinedInput,
              }}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setGlobalFilter('');
                        table.setGlobalFilter('');
                        setShowSearch(false); // 닫기
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                  ),
                }
              }}
            />
          </Collapse>
        </Box>
        {/* 추가 버튼 */}
        <Buttons.Add
          onClick={() => openAddModal()} // 행 생성 다이얼로그 열기
          sx={{ padding: '12px 16px' }}
        />
        {/* 삭제 버튼 */}
        <Buttons.Delete 
          onClick={openDeleteModal} // 행 삭제 로직 실행
          disabled={table.getSelectedRowModel().rows.length === 0}
          sx={{ padding: '12px 16px' }}
        />    
      </Box>
    </Box>
  );

  // 안전보건경영 목표 추가 모달 상태 관리
  const [addData, setAddData] = useState({ isOpen: false });
  const openAddModal = () => {
    setAddData({
      ...addData,
      isOpen: true,
    });
  };
  const closeAddModal = () =>{
    setAddData({
      ...addData,
      isOpen: false,
    });
  };
  // DB 업데이트 (추가 데이터)
  const updateAddData = async (addData) => {
    try {
      //console.log("새로운 데이터: ", addData);

      // 데이터베이스 업데이트
      const result = await postData.mutateAsync(addData);
      if(result.status === 200) {
        openDataAlert(message.addSuccess);
      }

      // 생성 모달 초기화
      closeAddModal();
    }
    catch (error) {
      console.error("데이터 추가 중 오류 발생:", error);
    }
  };

  // 안전보건경영 목표 수정 모달 상태 관리
  const [showEditModal, setShowEditModal] = useState({ isOpen: false, rowData: [] });
  const openEditModal = (rowData) => {
    setShowEditModal({
      ...showEditModal,
      isOpen: true,
      rowData: rowData,
    });
  };
  const closeEditModal = () =>{
    setShowEditModal({
      ...showEditModal,
      isOpen: false,
      rowData: [],
    });
  };
  // 안전보건경영 목표 수정 액션
  const customRenderRowActionContent = (rowData) => {
    return(
      <Buttons.Edit
        onClick={(event) =>{
          event.stopPropagation(); // 이벤트 전파 중단
          openEditModal(rowData);
        }}
        sx={{ padding: '8px 12px' }}
      />
    );
  };
  // DB 업데이트 (수정 데이터)
  const updateEditData = async (updateData) => {
    //console.log(updateData);
    try {
      const result = await putData.mutateAsync(updateData);
      if(result.status === 200) {
        openDataAlert(message.updateEditSuccess);
      }

      // 수정 모달 초기화
      closeEditModal();
    }
    catch (error) {
      console.error("데이터 수정 중 오류 발생:", error);
    }
  }

  // 행(row) 삭제 관련 함수 및 상태
  const [deleteModal, setDeleteModal] = useState({ isOpen: false });
  const openDeleteModal = () => setDeleteModal({ isOpen: true });
  const closeDeleteModal = () => setDeleteModal({ isOpen: false });
  // DB 업데이트 (삭제 데이터)
  const updateDeleteData = async () => {
    closeDeleteModal();
    //console.log('✅ 확인 눌림 → 다음 동작 실행');
    try {

      // 선택된 행(row) 가져오기
      const selectedRows = getSelectedRows().map((row) => row.original);
      // 선택된 행(row)의 id 가져오기
      const selectedIds = selectedRows.map((row) => row.goal_id);

      // 데이터베이스 업데이트
      const result = await deleteData.mutateAsync({
        deleteParam: 'goal_id',
        param: selectedIds,
      });

      if(result.status === 200) {
        openDataAlert(message.deleteSuccess);
      }

      // 선택 상태 초기화
      clearSelection();
      
    }
    catch (error) {
      console.error("데이터 삭제 중 오류 발생:", error);
    }
  };

  return (
    <TableContainer>
      {/** 안전보건경영 목표 테이블 */}
      <NewTableTemplate 
        ref={tableRef}
        columns={standardGoalColumns}
        data={getData.data}
        topToolbarContent={customTableTopToolbar}
        renderRowActionContent={customRenderRowActionContent}
        enableCustomGlobalFilter={true}
        templateSX ={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0.375rem", 
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
        }}
      />
      {/* 행(row) 추가 모달 */}
      <SafeGoalCreateRowModal 
        isOpen={addData.isOpen}
        originalRowData={[...getData.data]}
        onConfirm={updateAddData}
        onCancel={closeAddModal}
      />
      {/* 행(row) 수정 모달 */}
      <SafeGoalEditRowModal 
        isOpen={showEditModal.isOpen}
        originalRowData={showEditModal.rowData}
        onConfirm={updateEditData}
        onCancel={closeEditModal}
      />
      {/* 삭제 메시지 */}
      <ConfirmDialog
        open={deleteModal.isOpen}
        title="정말 삭제하시겠어요?"
        message="삭제하면 복구할 수 없습니다."
        onConfirm={updateDeleteData}
        onCancel={closeDeleteModal}
      />
      {/* 데이터 알람 */}
      <SnackbarAlert 
        open={dataAlert.isOpen}
        onClose={closeDataAlert}
        message={dataAlert.message}
        severity={dataAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        //anchorOrigin = {{vertical: "top", horizontal: "center"}}
      />
    </TableContainer>
  );
};
// 안전보건경영 목표의 행(row) 추가 모달
const SafeGoalCreateRowModal = ({ isOpen, originalRowData, onConfirm, onCancel }) => {
  const theme = useTheme();
  // const { group_code, project_code } = useParams();

  // 유효성 검사 알람 상태 관리
  const [validationAlert, setValidationAlert] = useState({
    isOpen: false,
    message: '',
    severity: '',
  });
  const openValidationAlert = (message, severity = 'error') => {
    setValidationAlert({
      ...validationAlert,
      isOpen: true,
      message: message,
      severity: severity,
    });
  };
  const closeValidationAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setValidationAlert({
      ...validationAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 추가 행 데이터 관리
  const [addData, setAddData] = useState([]);
  const clearAddData = () => setAddData([]);
  
    // 행 추가 완료
  const handleApplyAdd = () => {
    if(checkEmptyData(addData)) {
      openValidationAlert(message.notAllowedEmpty);
      return;
    } 

    //console.log("새로운 데이터: ", addData);

    onConfirm(addData);
    clearAddData();
  };

  ////////////////////////
  // Helper Functions
  ////////////////////////

  // 데이터 빈칸 체크
  const checkEmptyData = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때
    if(tempData.length === 0) { 
      return true;
    }

    // 데이터가 있을 때
    const hasValidData = tempData.some(
      item => !item.goal_description
    );
    return hasValidData;
  };

  // SafeGoalCreateRowModal 렌더링
  return (
    <ModalTemplate
      isOpen={isOpen}
      handleConfirm={handleApplyAdd}
      handleCancel={() => {
        clearAddData();
        onCancel();
      }}
      title="추가하기"
      cancelText="취소"
      confirmText="추가"
    >
      <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 3, py: 2}}>
        {/* 목표 */}
        <TextField
          label={'목표'}
          value={addData?.goal_description || ""}
          fullWidth
          onChange={(e) => {
            setAddData({
              ...addData,
              goal_description: e.target.value,
            });
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background.paper,
            },
          }}
        />
      </Box>

      {/* 유효성 검사 알람 */}
      <SnackbarAlert 
        open={validationAlert.isOpen}
        onClose={closeValidationAlert}
        message={validationAlert.message}
        severity={validationAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        // anchorOrigin = {{vertical: "top", horizontal: "center"}}
        snackBarSX={{width: '80%'}}
      />  
    </ModalTemplate>
  );
}
// 안전보건경영 목표의 행(row) 수정 모달
const SafeGoalEditRowModal = ({ isOpen, originalRowData, onConfirm, onCancel }) => {
  // const theme = useTheme();
  // const { group_code, project_code } = useParams();

  // 유효성 검사 알람 상태 관리(빈칸)
  const [validationAlert, setValidationAlert] = useState({
    isOpen: false,
    message: '',
    severity: '',
  });
  const openValidationAlert = (message, severity = 'error') => {
    setValidationAlert({
      ...validationAlert,
      isOpen: true,
      message: message,
      severity: severity,
    });
  };
  const closeValidationAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setValidationAlert({
      ...validationAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 수정 행 데이터 관리
  const [editData, setEditData] = useState([]);
  const clearEditData = () => setEditData([]);
  useEffect(() =>{
    setEditData(originalRowData);
  },[originalRowData])

  // 행 수정 완료
  const handleApplyEdit = () => {

    if(checkEmptyData(editData)) {
      openValidationAlert(message.notAllowedEmpty);
      return;
    } 
    //console.log("수정된 데이터:", editData);
    
    onConfirm(editData);
    clearEditData();
  };

  ////////////////////////
  // Helper Functions
  ////////////////////////

  // 데이터 빈칸 체크
  const checkEmptyData = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때
    if(tempData.length === 0) { 
      return true;
    }

    // 데이터가 있을 때
    const hasValidData = tempData.some(
      item => !item.goal_description
    );
    return hasValidData;
  };

  // SafeGoalCreateRowModal 렌더링
  return (
    <ModalTemplate
      isOpen={isOpen}
      handleConfirm={handleApplyEdit}
      handleCancel={() => {
        clearEditData();
        onCancel();
      }}
      title="수정하기"
      cancelText="취소"
      confirmText="수정"
      //contentSX={{ gap: "24px" }}
    >
      <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 3, py: 2}}>
        {/* 목표 */}
        <TextField
          label={'목표'}
          value={editData?.goal_description || ""}
          fullWidth
          onChange={(e) => {
            setEditData({
              ...editData,
              goal_description: e.target.value,
            });
          }}
        />
      </Box>

      {/* 유효성 검사 알람 */}
      <SnackbarAlert 
        open={validationAlert.isOpen}
        onClose={closeValidationAlert}
        message={validationAlert.message}
        severity={validationAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        // anchorOrigin = {{vertical: "top", horizontal: "center"}}
        snackBarSX={{width: '80%'}}
      />  
    </ModalTemplate>
  );
}

//---------------
/* =========================
 * 레이아웃 모드
 *  - 'fixed'                : X,Y 모두 고정값 사용 (ROLE_LAYOUT.x, ROLE_LAYOUT.y)
 *  - 'fixed-x-dynamic-y'    : X는 고정, Y는 실제 노드 높이 측정 후 레벨 간 간격 자동 확장
 * =========================*/
const LAYOUT_MODE = "fixed-x-dynamic-y";

/* =========================
 * role_id 기반 엣지 규칙 (왼쪽=source, 오른쪽들=target)
 * =========================*/
const EDGE_RULES_ID = {
  "ID:1": ["ID:2", "ID:3"],
  "ID:2": ["ID:4", "ID:5", "ID:6"],
  "ID:3": ["ID:6"],
  "ID:6": ["ID:7"],
};

// 규칙 키 파서: 'ID:6' -> 6
const parseKeyById = (key) => {
  const m = key.match(/^ID:(\d+)$/);
  return m ? Number(m[1]) : null;
};

/* =========================
 * 역할 메타(레벨/타이틀) — 더미 생성 시 필요
 *  실제 서비스에서는 API로 받아와도 됩니다.
 * =========================*/
// const ROLE_META = {
//   1: { level: 1, name: "Level1_역할(1)" },
//   2: { level: 2, name: "Level2_역할(1)" },
//   3: { level: 2, name: "Level2_역할(2)" },
//   4: { level: 3, name: "Level3_역할(1)" },
//   5: { level: 3, name: "Level3_역할(2)" },
//   6: { level: 3, name: "Level3_역할(3)" },
//   7: { level: 4, name: "Level4_역할(1)" },
// };

/* =========================
 * 고정 좌표 테이블 (role_id -> x,y?,level?)
 *  - fixed 모드: x,y 모두 사용
 *  - fixed-x-dynamic-y 모드: x와 level만 쓰고 y는 자동 계산
 * =========================*/
const ROLE_LAYOUT = {
  1: { x: 0,    y: 0,  level: 1 },
  2: { x: -350,         level: 2 },
  3: { x:  350,         level: 2 },
  4: { x: -350,         level: 3 },
  5: { x:   0,          level: 3 },
  6: { x:  350,         level: 3 },
  7: { x:  350,         level: 4 },
};

/* =========================
 * 더미 노드 보강:
 *  - 규칙에 등장하는 role_id를 수집
 *  - 실제 데이터에 없으면 ROLE_META/ROLE_LAYOUT을 참고해 더미 추가
 * =========================*/
function ensurePlaceholderGroups(groups, ROLE_META) {
  const have = new Set(groups.map((g) => Number(g.role_id)));
  const need = new Set();

  Object.entries(EDGE_RULES_ID).forEach(([from, tos]) => {
    const fid = parseKeyById(from);
    if (fid != null) need.add(fid);
    tos.forEach((t) => {
      const tid = parseKeyById(t);
      if (tid != null) need.add(tid);
    });
  });

  const out = [...groups];
  need.forEach((id) => {
    if (!have.has(id)) {
      const meta = ROLE_META[id] || { level: 0, name: `역할(${id})` };
      out.push({
        role_id: id,
        role_name: meta.name,
        // layout의 level이 있으면 우선, 없으면 meta.level
        role_level: ROLE_LAYOUT[id]?.level ?? meta.level ?? 0,
        people: [],
        isPlaceholder: true,
      });
    }
  });
  return out;
}

/* =========================
 * 배치 적용기:
 *  - fixed         : x=ROLE_LAYOUT.x, y=ROLE_LAYOUT.y (없으면 (lv-1)*baseY)
 *  - fixed-x-dynamic-y: x=ROLE_LAYOUT.x, 1차 y=(lv-1)*baseY (나중에 재배치)
 * =========================*/
function applyPositionsFromLayout(groups, roleLayout, baseYGap = 200, ROLE_META) {
  // level 푸시
  groups.forEach((g) => {
    g._level =
      roleLayout[g.role_id]?.level ??
      Number(g.role_level ?? ROLE_META[g.role_id]?.level ?? 0);
  });

  const positions = new Map();
  groups.forEach((g) => {
    const layout = roleLayout[g.role_id] || {};
    const x = layout.x ?? 0;
    const y =
      LAYOUT_MODE === "fixed"
        ? layout.y != null
          ? layout.y
          : (g._level - 1) * baseYGap
        : (g._level - 1) * baseYGap;
    positions.set(g, { x, y });
  });

  return { positions };
}

/* =========================
 * 다중 입력 핸들 지원을 위한 유입 맵 생성:
 *  toRoleId -> Set(fromRoleId)
 * =========================*/
function buildIncomingMapFromRules(rules) {
  const incoming = new Map();
  Object.entries(rules).forEach(([fromKey, toList]) => {
    const fromId = parseKeyById(fromKey);
    if (fromId == null) return;
    toList.forEach((toKey) => {
      const toId = parseKeyById(toKey);
      if (toId == null) return;
      if (!incoming.has(toId)) incoming.set(toId, new Set());
      incoming.get(toId).add(fromId);
    });
  });
  return incoming;
}

function buildTargetHandlesForRole(toRoleId, incomingMap) {
  const froms = Array.from(incomingMap.get(toRoleId) || []);
  const n = froms.length;
  if (n === 0) return [];
  return froms.map((fromId, idx) => ({
    id: `in-${fromId}`,
    fromRoleId: fromId,
    left: Math.round(((idx + 1) / (n + 1)) * 100), // 균등 분배
  }));
}

/* =========================
 * X 고정 + Y 자동 확장 (실측 높이 기반)
 *  - 각 레벨 maxHeight를 누적해 Y를 다시 배치
 * =========================*/
function useRecalcY() {
  const reactFlow = useReactFlow();
  const recalc = useCallback((nodes, groups, baseGap = 80) => {
    const getHeight = (id) => {
      const n = reactFlow.getNode(id);
      return n?.measured?.height ?? n?.height ?? 0;
    };
    const levels = Array.from(new Set(groups.map((g) => g._level))).sort(
      (a, b) => a - b
    );
    const maxHByLevel = new Map();
    levels.forEach((lv) => {
      const idsOnLv = groups
        .filter((g) => g._level === lv)
        .map((g) => `role-${g.role_id}`);
      const maxH = Math.max(0, ...idsOnLv.map(getHeight));
      maxHByLevel.set(lv, maxH || 0);
    });

    const yByLevel = new Map();
    let cursorY = 0;
    levels.forEach((lv, i) => {
      if (i === 0) {
        yByLevel.set(lv, 0);
        cursorY = (maxHByLevel.get(lv) || 0) + baseGap;
      } else {
        yByLevel.set(lv, cursorY);
        cursorY += (maxHByLevel.get(lv) || 0) + baseGap;
      }
    });

    return nodes.map((n) => {
      const roleId = Number(n.id.replace("role-", ""));
      const lv = groups.find((g) => g.role_id === roleId)?._level ?? 0;
      return { ...n, position: { x: n.position.x, y: yByLevel.get(lv) ?? n.position.y } };
    });
  }, [reactFlow]);

  return recalc;
}

/* =========================
 * 커스텀 역할 카드 (더미면 회색 점선 / 내용 숨김)
 *  + 다중 입력 핸들 지원 (data.targetHandles)
 * =========================*/
function RoleCardNode({ data, selected }) {
  const people = Array.isArray(data.people) ? data.people : [];
  const isPlaceholder = !!data.isPlaceholder;
  const targetHandles = Array.isArray(data.targetHandles) ? data.targetHandles : [];

  return (
    <div
      style={{
        width: 260,
        border: isPlaceholder
          ? "2px dashed rgba(200,200,200,0.7)"
          : selected
          ? "2px solid #1976d2"
          : "1px solid #333",
        borderRadius: 12,
        overflow: "hidden",
        boxShadow: isPlaceholder ? "none" : "0 6px 16px rgba(0,0,0,0.2)",
        background: isPlaceholder ? "#1a1f2a" : "#0f1420",
        color: isPlaceholder ? "rgba(220,220,220,0.8)" : "#fff",
        fontFamily: "Inter, system-ui, sans-serif",
        opacity: isPlaceholder ? 0.85 : 1,
        position: "relative",
      }}
      title={isPlaceholder ? "데이터 없음" : undefined}
    >
      {/* 타이틀 */}
      <div
        style={{
          padding: "10px 12px",
          fontWeight: FONT_PROPS.SEMIBOLD,
          fontSize: 14,
          background: isPlaceholder
            ? "transparent"
            : "linear-gradient(180deg, rgba(25,118,210,0.25), rgba(25,118,210,0.05))",
          borderBottom: isPlaceholder
            ? "1px dashed rgba(255,255,255,0.15)"
            : "1px solid rgba(255,255,255,0.08)",
          textAlign: "center",
        }}
      >
        {data.title || "역할"}
        {isPlaceholder && (
          <span style={{ display: "block", fontSize: 11, opacity: 0.8, marginTop: 2 }}>
            (데이터 없음)
          </span>
        )}
      </div>

      {/* 내용 */}
      {!isPlaceholder && (
        // <div style={{ padding: 10, maxHeight: 200, overflow: "auto" }}>
        <div style={{ padding: 10 }}>
          {people.length === 0 ? (
            <div style={{ opacity: 0.7, fontSize: 12 }}>구성원이 없습니다</div>
          ) : (
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {people.map((p) => (
                <li
                  key={p.org_id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "6px 4px",
                    borderBottom: "1px dashed rgba(255,255,255,0.08)",
                  }}
                >
                  <img
                    src={
                      p.img ||
                      `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
                        p.emp_name || ""
                      )}`
                    }
                    alt={p.emp_name}
                    style={{ width: 28, height: 28, borderRadius: "50%" }}
                  />
                  <div style={{ lineHeight: 1.2 }}>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{p.emp_name}</div>
                    {p.position && (
                      <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>
                        {p.position}
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

      {/* 다중 입력 핸들 */}
      {targetHandles.map((h) => (
        <Handle
          key={h.id}
          id={h.id}
          type="target"
          position={Position.Top}
          style={{ left: `${h.left}%` }}
        />
      ))}
      {/* 출력 핸들 */}
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
}

// 안전보건조직도
const SafeOrg = () => {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  ////////////////////////
  // CRUD 요청
  ////////////////////////
  // 시스템 환경 설정 조회 요청
  // const getSystempPropertyData = useGetTableDataInQueryString(
  //   "request",
  //   "/getSystemProperty",
  //   group_code,
  //   project_code,
  //   { params: { 
  //     [SystemProperty.COMPANY_SIZE]: SystemProperty.COMPANY_SIZE,
  //   }},
  // );
  // // 시스템 환경 설정 수정 요청
  // const putSystemPropertyData = usePutTableData(
  //   "request",
  //   "/putSystemProperty",
  //   group_code,
  //   project_code,
  // );
  // 안전 역할 조회 요청
  const getSafeRoleData = useGetTableData(
    "request",
    "/getSafeRole",
    group_code,
    project_code
  );

  // 데이터 조회 요청
  const getData = useGetTableData(
    "request",
    "/getSafeOrg", 
    group_code,
    project_code
  );
  const tempGetData = useMemo(() => getData.data || [], [getData.data]);

  // 역할 메타데이터 생성
  const ROLE_META = useMemo(() => (
    getSafeRoleData.data
      ? Object.fromEntries(
          getSafeRoleData.data.map(({ role_id, role_level, role_name }) => [
            role_id,
            { level: role_level, name: role_name },
          ])
        )
      : {}
  ), [getSafeRoleData.data]);

  const [nodes, setNodes, onNodesChange] = useNodesState([]); 
  const [edges, setEdges, onEdgesChange] = useEdgesState([]); // 카드 연결선
  const reactFlow = useReactFlow();
  const recalcY = useRecalcY();

  useEffect(() => {
    const rows = Array.isArray(tempGetData) && tempGetData.length > 0 ? tempGetData : [];

    // 1) role_id 기준 그룹화
    const map = new Map();
    rows.forEach((r) => {
      const key = Number(r.role_id);
      if (!map.has(key)) {
        map.set(key, {
          role_id: key,
          role_name: r.role_name ?? ROLE_META[key]?.name ?? `역할(${key})`,
          role_level: r.role_level ?? ROLE_META[key]?.level ?? ROLE_LAYOUT[key]?.level ?? 0,
          people: [],
          isPlaceholder: false,
        });
      }
      const g = map.get(key);
      g.people.push({
        org_id: r.org_id,
        emp_name: r.emp_name,
        position: r.role_name,
        img: `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
          r.emp_name || ""
        )}`,
      });
    });

    // 2) 규칙에 필요하지만 데이터에 없는 role_id → 더미 주입
    let groups = ensurePlaceholderGroups(Array.from(map.values()), ROLE_META);

    // 3) 초기 좌표 적용
    const { positions } = applyPositionsFromLayout(groups, ROLE_LAYOUT, 200, ROLE_META);

    // 4) 다중 입력 핸들을 위해 incoming 맵 생성
    const incomingMap = buildIncomingMapFromRules(EDGE_RULES_ID);

    // 5) 노드 생성 (초기 position)
    let newNodes = groups.map((g) => ({
      id: `role-${g.role_id}`,
      type: "roleCard",
      position: positions.get(g) || { x: 0, y: 0 },
      data: {
        title: g.role_name || `역할(${g.role_id})`,
        people: g.people,
        isPlaceholder: g.isPlaceholder,
        targetHandles: buildTargetHandlesForRole(g.role_id, incomingMap),
      },
    }));

    // 6) 엣지 생성 (targetHandle로 from별 전용 포트 연결)
    const idToNodeId = new Map(
      newNodes.map((n) => [Number(n.id.replace("role-", "")), n.id])
    );
    const newEdges = [];
    Object.entries(EDGE_RULES_ID).forEach(([fromKey, toKeys]) => {
      const fromId = parseKeyById(fromKey);
      const fromNodeId = idToNodeId.get(fromId);
      if (!fromNodeId) return;

      toKeys.forEach((toKey) => {
        const toId = parseKeyById(toKey);
        const toNodeId = idToNodeId.get(toId);
        if (!toNodeId) return;

        newEdges.push({
          id: `e-${fromNodeId}-${toNodeId}`,
          source: fromNodeId,
          target: toNodeId,
          targetHandle: `in-${fromId}`, // ← fromId별 전용 입력 포트로 연결
          type: "smoothstep",
          animated: true,
          style: { stroke: alpha('#565656', 0.5), strokeWidth: 2 }, // 선 색/두께
          markerEnd: { type: 'arrowclosed', color: alpha('#565656', 1) }, // 화살표 색
        });
      });
    });

    setNodes(newNodes);
    setEdges(newEdges);

    // 7) 높이 측정 후 Y 재배치 (fixed-x-dynamic-y 모드일 때)
    if (LAYOUT_MODE === "fixed-x-dynamic-y") {
      setTimeout(() => {
        setNodes((curr) => recalcY(curr, groups, 80));
        setTimeout(() => reactFlow.fitView({ padding: 0.2 }), 20);
      }, 60);
    }
  }, [tempGetData, setNodes, setEdges, recalcY, reactFlow, ROLE_META]);

  

  // 편집 상태관리
  const [showEdit, setShowEdit] = useState(false);
  const openEdit = () => setShowEdit(true);
  const closeEdit = () => setShowEdit(false);

  // 최소 읽기 가능한 줌
  const MIN_READABLE_ZOOM = 0.75;

  // SafeOrg 렌더링
  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh', zIndex: 0 }}>
      {/** 우측 상단 기능 */}
      <div style={{ position: 'absolute', top: 20, right: 30, zIndex: 10 }}>
        {/** 편집 버튼 */}
        <Buttons.Edit
          children="편집"
          onClick={openEdit}
          sx={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 16px',}}
        />
      </div>
      {/* 편집 UI */}
      {showEdit && 
        <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 10 }}>
          <Box sx={{ width: '55vw',height: '80vh', bgcolor: '#FFFFFF', border: `1px solid ${theme.palette.divider}`, borderRadius: '0.375rem', boxShadow: 2, display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ height: 60, borderBottom: `1px solid ${theme.palette.divider}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography sx={{ fontWeight: FONT_PROPS.MEDIUM, fontSize: 16, px: 6, py: 3 }}>
                조직도 설정
              </Typography>
              <Buttons.Custom
                onClick={() => { closeEdit(); }}
                startIcon={<CloseIcon />}
                sx={{ padding: '12px 16px', mr: 2 }}
              >
                닫기
              </Buttons.Custom>
            </Box>
            {/* 조직도 설정 */}
            <Box sx={{ width: '100%', height: 'calc(100% - 40px)' }}> 
              <SafeRoleOrgEdit 
                safeOrgData={getData.data || []} 
                safeRoleData={getSafeRoleData.data || []}
              />
            </Box>
          </Box>
        </div>
      }

      {/* 리액트 플로우 */}
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onInit={(instance) => {
          setTimeout(() => {
            instance.fitView({ padding: 0.2 });
            // v12에서 viewport 조회
            const z = typeof instance.getZoom === 'function'
              ? instance.getZoom()
              : instance.getViewport?.().zoom;
            if (z < MIN_READABLE_ZOOM) {
              instance.zoomTo(MIN_READABLE_ZOOM, { duration: 150 });
            }
          }, 30);
        }}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={(p) => setEdges((eds) => addEdge(p, eds))} // 변경 감지 및 자동 처리
        nodeTypes={useMemo(() => ({ roleCard: RoleCardNode }), [])} // 커스텀 노드로 연결
        fitView // 자동 줌 조절(처음 로딩 시 모든 노드가 화면에 다 보이게 줌 조절)
        minZoom={0.1} // 최소 줌 (기본: 0.5)
        maxZoom={2} // 최대 줌 (기본: 2)
        proOptions={{ hideAttribution: true }}
      >
        <MiniMap />
        <Controls />
        <Background />
      </ReactFlow>
      {/* <ReactFlow
        nodes={nodes} // 현재 상태를 전달
        edges={edges} // 현재 상태를 전달
        onInit={handleInit}     
        onNodesChange={onNodesChange} // 변경 감지 및 자동 처리
        onEdgesChange={onEdgesChange}
        onConnect={onConnect} // 변경 감지 및 자동 처리
        nodeTypes={nodeTypes} // 커스텀 노드로 연결
        fitView // 자동 줌 조절(처음 로딩 시 모든 노드가 화면에 다 보이게 줌 조절)
        minZoom={0.5} // 최소 줌 (기본: 0.5)
        maxZoom={2} // 최대 줌 (기본: 2)
        proOptions={{ hideAttribution: true }}
      >
        <MiniMap />
        <Controls />
        <Background />
      </ReactFlow> */}
    </div>
  );
}
// 조직도 설정
const SafeRoleOrgEdit = ({ safeOrgData, safeRoleData }) => {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  ////////////////////////
  // CRUD 요청
  ////////////////////////
  // 직원 조회 요청
  const getEmployeeData = useGetTableData(
    "request",
    "/getStandardEmployee",
    group_code,
    project_code
  );

  // 데이터 생성 요청
  const postData = useCreateTableData( 
    "request",
    "/postSafeOrg",
    group_code,
    project_code
  );  
  // 데이터 삭제 요청
  const deleteData = useDeleteTableData(
    "request",
    "/deleteSafeOrg",
    group_code,
    project_code
  );

  /**
   * tempData 데이터 구조
   *  [
   *    {
          safeRoleData: { role_id: 1, ... },
          employeeData:
          [
            { emp_id:1, ... },
            { emp_id:2, ... },
            ...
          ]
        },
        ...
      ]
  */

  const [tempData, setTempData] = useState([]);
  useEffect(() => {

    const originalRowData = deepCopy(safeOrgData);

    // 1. originalRowData를 role_id 기준으로 그룹핑
    const employeeMap = originalRowData.reduce((acc, cur) => {
      const { org_id, note,
        emp_id, emp_name, department_name, position_name,
        role_id, role_name, role_level } = cur;
      if(!acc[role_id]) acc[role_id] = [];
      acc[role_id].push({ 
        org_id, 
        note,
        emp_id, 
        emp_name,
        department_name,
        position_name,
        role_id,
        role_name,
        role_level,
      });
      return acc;
    }, {});

    // 2. safeRoleData를 기준으로 전체 safeRoleData 유지
    const grouped = safeRoleData.map(role => ({
      safeRoleData: {
        role_id: role.role_id,
        role_name: role.role_name,
        role_level: role.role_level,
      },
      // originalData에 해당 role_id 있으면 employeeData 채우기
      employeeData: employeeMap[role.role_id] || [],
    }));

    // 편집 데이터 보관
    setTempData(deepCopy(grouped));
  },[safeRoleData, safeOrgData]);

  // 데이터 업데이트 알람 상태 관리
  const [dataAlert, setDataAlert] = useState({
    isOpen: false,
    message: '',
    severity:'' // 'success' | 'error' | 'warning' | 'info'
  });
  const openValidationAlert = (message, severity = 'success') => {
    setDataAlert({
      ...dataAlert,
      isOpen: true,
      message: message,
      severity: severity
    });
  };
  const closeValidationAlert = () => {
    setDataAlert({
      ...dataAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 선택한 조직도 설정 항목 관리
  const [selectedEditItems, setSelectedEditItems] = useState({ roleIds: [] });
  const setEditItemSelect = ({ roleIds }) => setSelectedEditItems({ roleIds });

  // 조직도 설정 테이블 참조
  const safeRoleEmployeeTableRef = useRef();
  const clearSafeRoleEmployeeSelection = () => { safeRoleEmployeeTableRef.current?.clearSelection(); };
  const getSafeRoleEmployeeSelectedRows = () => { return safeRoleEmployeeTableRef.current?.getSelectedRows(); };

  // 조직도 설정 테이블의 상단 툴바 커스터마이징 관련 내용
  const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
  const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
  const customSafeRoleEmployeeTableTopToolbar = (table) => {
    const data = table.getSelectedRowModel().rows.map(row => row.original);
    const hasData = data.filter(item => {
      return Array.isArray(item.employeeData) && item.employeeData.length > 0;
    });
    const isDeleteDisabled = hasData.length === 0;

    return (
      <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
        {/* 왼쪽 영역 */}
        <Box display="flex" alignItems="center" gap={2}>
          {/* TODO: */}
        </Box>

        {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
        <Box display="flex" alignItems="center" gap={2}>
          {/* 검색창 */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton onClick={() => setShowSearch((prev) => !prev)}>
              <SearchIcon />
            </IconButton>
          
            <Collapse in={showSearch} orientation="horizontal">
              <TextField
                size="small"
                placeholder="검색"
                value={globalFilter}
                onChange={(e) => {
                  setGlobalFilter(e.target.value);
                  table.setGlobalFilter(e.target.value);
                }}
                sx={{ minWidth: 200 }}
                variant="outlined"
                slots={{
                  input: OutlinedInput,
                }}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                          setGlobalFilter('');
                          table.setGlobalFilter('');
                          setShowSearch(false); // 닫기
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }
                }}
              />
            </Collapse>
          </Box>

          {/* 삭제 버튼 */}
          <Buttons.Delete
            onClick={() => {
              openDeleteRecordModal(data);
            }}
            disabled={isDeleteDisabled}
            sx={{ padding: '12px 16px' }}
          />
        </Box>
      </Box>
    );
  };

  // 레코드 삭제 모달 상태 관리
  const [deleteRecordModal, setDeleteRecordModal] = useState({ isOpen: false, deleteItem: null });
  const openDeleteRecordModal = (item) => setDeleteRecordModal({ isOpen: true, deleteItem: item });
  const closeDeleteRecordModal = () => setDeleteRecordModal({ isOpen: false, deleteItem: null });

  // DB 업데이트 (데이터 삭제) 
  const deleteSafeOrgData = async () => {
    closeDeleteRecordModal();
    //console.log('✅ 확인 눌림 → 다음 동작 실행');
    try {
      const data = deleteRecordModal.deleteItem.flatMap(item => {
        return item.employeeData.map(e => ({ org_id: e.org_id }))
      });

      // 데이터베이스 업데이트
      const result = await deleteData.mutateAsync({
        deleteData: data
      });

      if(result.status === 200) {
        openValidationAlert(message.deleteSuccess);
      }

      // 선택 상태 초기화
      clearSafeRoleEmployeeSelection();
    }
    catch (error) {
      console.error("데이터 삭제 중 오류 발생:", error);
    }
  };

  const employeeRows = useMemo(
    () => (Array.isArray(getEmployeeData.data) ? getEmployeeData.data : []),
    [getEmployeeData.data]
  );
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const selectedEmployeeRows = useMemo(() => {
    const selectedSet = new Set(selectedEmployeeIds.map(Number));
    return employeeRows.filter((employee) => selectedSet.has(Number(employee.emp_id)));
  }, [employeeRows, selectedEmployeeIds]);

  const clearEmployeeSelection = () => setSelectedEmployeeIds([]);
  const selectEmployee = (employee, checked) => {
    const empId = Number(employee.emp_id);
    if (!empId) return;
    setSelectedEmployeeIds((prev) => {
      const next = new Set(prev.map(Number));
      if (checked) next.add(empId);
      else next.delete(empId);
      return Array.from(next);
    });
  };
  const selectEmployees = (employees) => {
    setSelectedEmployeeIds((prev) => {
      const next = new Set(prev.map(Number));
      employees.forEach((employee) => {
        const empId = Number(employee.emp_id);
        if (empId) next.add(empId);
      });
      return Array.from(next);
    });
  };
  const deselectEmployees = (employees) => {
    const removeSet = new Set(employees.map((employee) => Number(employee.emp_id)));
    setSelectedEmployeeIds((prev) => prev.map(Number).filter((id) => !removeSet.has(id)));
  };

  // 직원 정보 추가
  const addEmployee = ({ roleIds }) => {
    // 선택한 항목
    const selectedEmployees = selectedEmployeeRows;

    // 선택 체크
    if (selectedEmployees.length === 0) {
      openValidationAlert(message.retrySelectedEmployeeList, "error");
      return;
    }

    // 중복 체크 및 추가할 데이터 구성
    const updateData = tempData.reduce((acc, item) => {
      if (!roleIds.includes(item.safeRoleData.role_id)) {
        return acc;
      }

      // 새로 추가된 employee 추출
      const newEmployees = selectedEmployees.filter(
        (m) => !item.employeeData.some((om) => om.emp_id === m.emp_id)
      );

      if (newEmployees.length > 0) {
        acc.push({
          safeRoleData: item.safeRoleData,
          employeeData: newEmployees,
        });
      }
      return acc;
    }, []);

    //console.log("추가할 데이터: ", updateData);

    // 추가된 항목이 있다면 업데이트
    if (updateData.length > 0) {
      addSafeOrgData(updateData);
    }

    // 중복이 있든 없든 항상 선택 해제
    clearEmployeeSelection();
  };
  // DB 업데이트(추가 데이터)
  const addSafeOrgData = async (updateData) => {
    try {
      //console.log("편집 데이터: ", updateData);

      // 데이터베이스 업데이트
      const result = await postData.mutateAsync(updateData);
      if(result.status === 200) {
        openValidationAlert(message.addSuccess);
      }
    }
    catch (error) {
      console.error("데이터 추가 중 오류 발생:", error);  
    }
  };

  return(
    <Box sx={{ display: "flex", flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 2, p: 2 }}>
      {/** 조직도 설정 테이블 */}
      <Box sx={{ display: "flex", flexDirection: 'column', width: '55%', border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)' }}>
        <NewTableTemplate 
          ref={safeRoleEmployeeTableRef}
          columns={standardSafeOrgColumns}
          data={tempData}
          topToolbarContent={customSafeRoleEmployeeTableTopToolbar}
          onSelectedRowsChange={(rowIds) => {
            const ids = getSafeRoleEmployeeSelectedRows().map(id => {
              return id.original.safeRoleData.role_id;
            });
            setEditItemSelect({ roleIds: ids });
          }}
          // enabledSelectionRow={mode !== RenderState.VIEW}
          enableEditing={false}
          enableCustomGlobalFilter={true}
          editDisplayMode={'row'}
          renderRowActionCustomOptions={({ values, row, table }) => {
            const normalizedValues = normalizeToArray(values);
            openDeleteRecordModal(normalizedValues);
          }}
          // templateSX={{
          //   border: `1px solid ${theme.palette.divider}`,
          //   borderRadius: "0.375rem", 
          //   boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
          // }}
        />
      </Box>
      {/** 직원 정보 선택 */}
      <Box sx={{ display: "flex", flexDirection: 'column', width: '45%', border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)' }}>
        {/** 제목 표시 */}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: '100%', height: '35px', bgcolor: theme.palette.primary.lighterOpacity, padding: '8px',}}>
          <Box sx={{ display: "flex", flex: 1, justifyContent: 'center', alignItems: "center", }}>
            <Typography sx={{ fontWeight: FONT_PROPS.MEDIUM, fontSize: 15, color: theme.palette.primary.main }}>
              직원 선택
            </Typography>
          </Box>
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', p: 1.5 }}>
          <EmployeeBulkPicker
            employees={employeeRows}
            selectedIds={selectedEmployeeIds}
            title="직원"
            selectedLabel="선택"
            helperText="팀을 먼저 고르거나 이름·사번으로 검색해서 역할에 추가할 직원을 선택합니다."
            listHeight="calc(100vh - 470px)"
            fixedListHeight
            onSelectEmployee={selectEmployee}
            onSelectEmployees={selectEmployees}
            onDeselectEmployees={deselectEmployees}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.5 }}>
            <Buttons.Custom
              onClick={() => {
                addEmployee({ roleIds: selectedEditItems.roleIds });
              }}
              disabled={
                selectedEditItems.roleIds.length === 0 || selectedEmployeeRows.length === 0
              }
              sx={{ padding: '10px 16px' }}
            >
              선택 직원 추가
            </Buttons.Custom>
          </Box>
        </Box>
      </Box>
      {/** 레코드 삭제 메시지 */}
      <ConfirmDialog
        open={deleteRecordModal.isOpen}
        title="정말 삭제하시겠어요?"
        message="삭제하면 복구할 수 없습니다."
        onConfirm={deleteSafeOrgData}
        onCancel={closeDeleteRecordModal}
      />
      {/* 데이터 알람 */}
      <SnackbarAlert 
        open={dataAlert.isOpen}
        onClose={closeValidationAlert}
        message={dataAlert.message}
        severity={dataAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        //anchorOrigin = {{vertical: "top", horizontal: "center"}}
      />
    </Box>
  );
};

//---------------

// 안전보건 역할 관리 컴포넌트
const SafeRoleManagement = () => {
  const theme = useTheme();
  const { group_code, project_code } = useParams();

  ////////////////////////
  // CRUD 요청
  ////////////////////////

  // 데이터 조회
  const getData = useGetTableData(
    "request",
    "/getSafeRoleManagement", 
    group_code,
    project_code
  );
  // 데이터 추가
  const postData = useCreateTableData(
    "request",
    "/postSafeRoleManagement",
    group_code,
    project_code
  );
  // 데이터 수정
  const putData = usePutTableData(
    "request",
    "/putSafeRoleManagement",
    group_code,
    project_code
  );
  // 데이터 삭제
  const deleteData = useDeleteTableData(
    "request",
    "/deleteSafeRoleManagement",
    group_code,
    project_code
  );

  const tempGetData = getData.data || [];

  // 데이터 업데이트 알람 상태 관리
  const [dataAlert, setDataAlert] = useState({
    isOpen: false,
    message: '',
    severity:'' // 'success' | 'error' | 'warning' | 'info'
  });
  const openDataAlert = (message, severity = 'success') => {
    setDataAlert({
      ...dataAlert,
      isOpen: true,
      message: message,
      severity: severity
    });
  };
  const closeDataAlert = () => {
    setDataAlert({
      ...dataAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 행 추가 모달 상태 관리
  const [showAddModal, setShowAddModal] = useState({ isOpen: false });
  const openAddModal = () => setShowAddModal({ isOpen: true });
  const closeAddModal = () => setShowAddModal({ isOpen: false });

  // 테이블 참조
  const tableRef = useRef();
  const clearSelection = () => { tableRef.current?.clearSelection(); };
  const getSelectedRows = () => { return tableRef.current?.getSelectedRows(); };

  // 테이블의 상단 툴바 커스터마이징 관련 내용
  const [showSearch, setShowSearch] = useState(false); // 검색창 열림 여부
  const [globalFilter, setGlobalFilter] = useState(''); // 검색 텍스트 상태
  const customTableTopToolbar = (table) => (
    <Box width="100%" display="flex" justifyContent="space-between" alignItems="center" p={2}>
      {/* 왼쪽 영역 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* TODO: */}
      </Box>
      {/* 오른쪽 영역 - 기존 내부 액션도 원하면 여기에 직접 렌더링 */}
      <Box display="flex" alignItems="center" gap={2}>
        {/* 검색창 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setShowSearch((prev) => !prev)}>
            <SearchIcon />
          </IconButton>
          <Collapse in={showSearch} orientation="horizontal">
            <TextField
              size="small"
              placeholder="검색"
              value={globalFilter}
              onChange={(e) => {
                setGlobalFilter(e.target.value);
                table.setGlobalFilter(e.target.value);
              }}
              sx={{ minWidth: 200 }}
              variant="outlined"
              slots={{
                input: OutlinedInput,
              }}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setGlobalFilter('');
                        table.setGlobalFilter('');
                        setShowSearch(false); // 닫기
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                  ),
                }
              }}
            />
          </Collapse>
        </Box>
        {/* 추가 버튼 */}
        <Buttons.Add
          onClick={() => openAddModal()} // 행 생성 다이얼로그 열기
          sx={{ padding: '12px 16px' }}
        />
        {/* 삭제 버튼 */}
        <Buttons.Delete 
          onClick={() => openDeleteModal()} // 행 삭제 로직 실행
          disabled={table.getSelectedRowModel().rows.length === 0}
          sx={{ padding: '12px 16px' }}
        />    
      </Box>
    </Box>
  );

  // DB 업데이트(추가 데이터)
  const updateAddData = async (addData) => {
    try {
      //console.log(addData);
      // 데이터베이스 업데이트
      const result = await postData.mutateAsync(addData);
      if(result.status === 200) {
        openDataAlert(message.addSuccess);
      }

      // 생성 모달 초기화
      closeAddModal();
    } catch (error) {
      console.error("데이터 추가 중 오류 발생:", error);
    }
  };

  // 행 수정 모달 상태 관리
  const [showEditModal, setShowEditModal] = useState({ isOpen: false, rowData: [] });
  const openEditModal = (rowData) => {
    setShowEditModal({
      ...showEditModal,
      isOpen: true,
      rowData: rowData,
    });
  };
  const closeEditModal = () =>{
    setShowEditModal({
      ...showEditModal,
      isOpen: false,
      rowData: null,
    });
  };
  // 테이블의 행(row) 수정 액션
  const customRenderRowActionContent = (rowData) => {
    return(
      <Buttons.Edit
        onClick={(event) =>{
          event.stopPropagation(); // 이벤트 전파 중단
          openEditModal(rowData);
        }}
        sx={{ padding: '8px 12px' }}
      />
    );
  };
  // DB 업데이트 (수정 데이터)
  const updateEditData = async (updateData) => {
    //console.log(updateData);
    try {
      const result = await putData.mutateAsync(updateData);
      if(result.status === 200) {
        openDataAlert(message.updateEditSuccess);
      }

      // 수정 모달 초기화
      closeEditModal();
    }
    catch (error) {
        console.error("데이터 수정 중 오류 발생:", error);
    }
  }

  // 행(row) 삭제 관련 함수 및 상태
  const [deleteModal, setDeleteModal] = useState({ isOpen: false });
  const openDeleteModal = () => setDeleteModal({ isOpen: true });
  const closeDeleteModal = () => setDeleteModal({ isOpen: false });
  // DB 업데이트 (삭제 데이터)
  const updateDeleteData = async () => {
    closeDeleteModal();
    //console.log('✅ 확인 눌림 → 다음 동작 실행');
    try {

      // 선택된 행(row) 가져오기
      const selectedRows = getSelectedRows().map((row) => row.original);
      // 선택된 행(row)의 id 가져오기
      const selectedIds = selectedRows.map((row) => row.ohs_id);

      // 데이터베이스 업데이트
      const result = await deleteData.mutateAsync({
        deleteParam: 'ohs_id',
        param: selectedIds,
      });

      if(result.status === 200) {
        openDataAlert(message.deleteSuccess);
      }

      // 선택 상태 초기화
      clearSelection();
    }
    catch (error) {
      console.error("데이터 삭제 중 오류 발생:", error);
    }
  };

  return (
    <TableContainer>
      {/** 안전보건경영 목표 테이블 */}
      <NewTableTemplate 
        ref={tableRef}
        columns={standardSafeRoleManagementColumns}
        data={tempGetData}
        // data={getData.data}
        topToolbarContent={customTableTopToolbar}
        renderRowActionContent={customRenderRowActionContent}
        enableCustomGlobalFilter={true}
        templateSX ={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "0.375rem", 
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
        }}
      />
      {/* 행(row) 추가 모달 */}
      <SafeRoleManagementCreateRowModal 
        isOpen={showAddModal.isOpen}
        onConfirm={updateAddData}
        onCancel={closeAddModal}
      />
      {/* 행(row) 수정 모달 */}
      <SafeRoleManagementEditRowModal 
        isOpen={showEditModal.isOpen}
        originalRowData={showEditModal.rowData}
        onConfirm={updateEditData}
        onCancel={closeEditModal}
      />
      {/* 삭제 메시지 */}
      <ConfirmDialog
        open={deleteModal.isOpen}
        title="정말 삭제하시겠어요?"
        message="삭제하면 복구할 수 없습니다."
        onConfirm={updateDeleteData}
        onCancel={closeDeleteModal}
      />
      {/* 데이터 알람 */}
      <SnackbarAlert 
        open={dataAlert.isOpen}
        onClose={closeDataAlert}
        message={dataAlert.message}
        severity={dataAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        //anchorOrigin = {{vertical: "top", horizontal: "center"}}
      />
    </TableContainer>
  );
};
// 안전보건관리체계 조직 역할 추가 모달
const SafeRoleManagementCreateRowModal = ({ isOpen, onConfirm, onCancel }) => {
  const theme = useTheme();

  // 유효성 검사 알람 상태 관리
  const [validationAlert, setValidationAlert] = useState({
    isOpen: false,
    message: '',
    severity: '',
  });
  const openValidationAlert = (message, severity = 'error') => {
    setValidationAlert({
      ...validationAlert,
      isOpen: true,
      message: message,
      severity: severity,
    });
  };
  const closeValidationAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setValidationAlert({
      ...validationAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 추가 데이터 상태 관리 (role, compliant, appointment, duty)
  const [addData, setAddData] = useState([]);
  const clearAddData = () => setAddData([]);

  // 행 추가 완료
  const handleApplyAdd = () => {
    if(checkEmptyData(addData)) {
      openValidationAlert(message.notAllowedEmpty);
      return;
    } 

    onConfirm(addData);
    clearAddData();
  };

  // 데이터 빈칸 체크
  const checkEmptyData = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때 
    if(tempData.length === 0) return true;

    // 데이터가 있을 때
    const hasValidData = tempData.some(
      item => !item.ohs_role || !item.ohs_comp || !item.ohs_app || !item.ohs_duty
    );
    return hasValidData;
  };

  return(
    <ModalTemplate
      isOpen={isOpen}
      handleConfirm={handleApplyAdd}
      handleCancel={() => {
        clearAddData();
        onCancel();
      }}
      title="추가하기"
      cancelText="취소"
      confirmText="추가"
      containerSX={{ width: 600, height: 'auto' }}
    >
      <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 3, py: 2}}>
        {/* 구분 */}
        <TextField
          label={'구분'}
          value={addData?.ohs_role || ""}
          fullWidth
          multiline
          minRows={2}
          maxRows={3}
          onChange={(e) => {
            setAddData({
              ...addData,
              ohs_role: e.target.value,
            });
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background.paper,
            },
          }}
        />
        {/* 적용 제조 사업장(상시 근로자 수) */}
        <TextField
          label={'적용 제조 사업장(상시 근로자 수)'}
          value={addData?.ohs_comp || ""}
          fullWidth
          multiline
          minRows={2}
          maxRows={3}
          onChange={(e) => {
            setAddData({
              ...addData,
              ohs_comp: e.target.value,
            });
          }}
        />
        {/* 선임대상 및 자격 */}
        <TextField
          label={'선임대상 및 자격'}
          value={addData?.ohs_app || ""}
          fullWidth
          multiline
          minRows={2}
          maxRows={3}
          onChange={(e) => {
            setAddData({
              ...addData,
              ohs_app: e.target.value,
            });
          }}
        />
        {/* 주요 임무 */}
        <Typography sx={{ color: 'text.secondary', fontWeight: FONT_PROPS.REGULAR, fontSize: 15 }}>주요 임무</Typography>
        <Box sx={{ border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)', overflow: 'hidden', p: 2, }}>
          <BulletTextField
            value={addData?.ohs_duty || ""}
            //defaultBullet="•"
            onChange={(raw, parsedItems) => { // 자식이 바뀔 때마다 올라옴
              setAddData({
                ...addData,
                ohs_duty: raw,
              });
              //setContent(raw);
              //setItems(parsedItems);
            }}
            //onBulletChange={(b) => console.log("bullet changed:", b)}
          />
        </Box>
      </Box>

      {/* 유효성 검사 알람 */}
      <SnackbarAlert 
        open={validationAlert.isOpen}
        onClose={closeValidationAlert}
        message={validationAlert.message}
        severity={validationAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        // anchorOrigin = {{vertical: "top", horizontal: "center"}}
        snackBarSX={{width: '80%'}}
      />  
    </ModalTemplate>
  );
};
// 안전보건관리체계 조직 역할 수정 모달
const SafeRoleManagementEditRowModal = ({ isOpen, originalRowData, onConfirm, onCancel }) => {

  const theme = useTheme();

  // 유효성 검사 알람 상태 관리(빈칸)
  const [validationAlert, setValidationAlert] = useState({
    isOpen: false,
    message: '',
    severity: '',
  });
  const openValidationAlert = (message, severity = 'error') => {
    setValidationAlert({
      ...validationAlert,
      isOpen: true,
      message: message,
      severity: severity,
    });
  };
  const closeValidationAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    setValidationAlert({
      ...validationAlert,
      isOpen: false,
      message: '',
      severity: '',
    });
  };

  // 수정 행 데이터 관리
  const [editData, setEditData] = useState([]);
  const clearEditData = () => setEditData([]);
  useEffect(() =>{
    setEditData(originalRowData);
  },[originalRowData])

  // 행 수정 완료
  const handleApplyEdit = () => {

    if(checkEmptyData(editData)) {
      openValidationAlert(message.notAllowedEmpty);
      return;
    } 
    //console.log("수정된 데이터:", editData);

    onConfirm(editData);
    clearEditData();
  };

  // 데이터 빈칸 체크
  const checkEmptyData = (data) => {
    const tempData = Array.isArray(data)? [...data]: [...[data]]; // 배열이 아닌 경우 배열로 변환 후 복제

    // 데이터가 없을 때
    if(tempData.length === 0) { 
      return true;
    }

    // 데이터가 있을 때
    const hasValidData = tempData.some(
      item => !item.ohs_role || !item.ohs_comp || !item.ohs_app || !item.ohs_duty
    );
    return hasValidData;
  };

  return(
    <ModalTemplate
      isOpen={isOpen}
      handleConfirm={handleApplyEdit}
      handleCancel={() => {
        clearEditData();
        onCancel();
      }}
      title="수정하기"
      cancelText="취소"
      confirmText="수정"
      containerSX={{ width: 600, height: 'auto' }}
    >
      <Box sx={{ display: "flex", flexDirection: 'column', flex: 1, width: '100%', height: '100%', overflow: 'hidden', gap: 3, py: 2}}>
        {/* 구분 */}
        <TextField
          label={'구분'}
          value={editData?.ohs_role || ""}
          fullWidth
          multiline
          minRows={2}
          maxRows={3}
          onChange={(e) => {
            setEditData({
              ...editData,
              ohs_role: e.target.value,
            });
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background.paper,
            },
          }}
        />
        {/* 적용 제조 사업장(상시 근로자 수) */}
        <TextField
          label={'적용 제조 사업장(상시 근로자 수)'}
          value={editData?.ohs_comp || ""}
          fullWidth
          multiline
          minRows={2}
          maxRows={3}
          onChange={(e) => {
            setEditData({
              ...editData,
              ohs_comp: e.target.value,
            });
          }}
        />
        {/* 선임대상 및 자격 */}
        <TextField
          label={'선임대상 및 자격'}
          value={editData?.ohs_app || ""}
          fullWidth
          multiline
          minRows={2}
          maxRows={3}
          onChange={(e) => {
            setEditData({
              ...editData,
              ohs_app: e.target.value,
            });
          }}
        />
        {/* 주요 임무 */}
        <Typography sx={{ color: 'text.secondary', fontWeight: FONT_PROPS.REGULAR, fontSize: 15 }}>주요 임무</Typography>
        <Box sx={{ border: `1px solid ${theme.palette.divider}`, borderRadius: "0.375rem", boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)', overflow: 'hidden', p: 2, }}>
          <BulletTextField
            value={editData?.ohs_duty || ""}
            //defaultBullet="•"
            onChange={(raw, parsedItems) => { // 자식이 바뀔 때마다 올라옴
              setEditData({
                ...editData,
                ohs_duty: raw,
              });
              //setContent(raw);
              //setItems(parsedItems);
            }}
            //onBulletChange={(b) => console.log("bullet changed:", b)}
          />
        </Box>
      </Box>

      {/* 유효성 검사 알람 */}
      <SnackbarAlert 
        open={validationAlert.isOpen}
        onClose={closeValidationAlert}
        message={message.notAllowedEmpty}
        severity={validationAlert.severity} // 'success' | 'error' | 'warning' | 'info'
        // anchorOrigin = {{ vertical: "top", horizontal: "center" }}
        snackBarSX={{width: '80%'}}
      /> 
    </ModalTemplate>
  );
};
